
import * as React from "react"
import { cn } from "@/lib/utils"

// Simplified ScrollArea component to avoid ref issues
const ScrollArea = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, forwardedRef) => {
  const refCallback = React.useCallback(
    (node: HTMLDivElement | null) => {
      if (typeof forwardedRef === "function") {
        forwardedRef(node)
      } else if (forwardedRef) {
        // @ts-ignore
        forwardedRef.current = node
      }
    },
    [forwardedRef]
  )

  return (
    <div
      ref={refCallback}
      className={cn("relative overflow-auto", className)}
      {...props}
    >
      {children}
    </div>
  )
})
ScrollArea.displayName = "ScrollArea"


export { ScrollArea }
